import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/articles/page.tsx");
